import TrashFilled from 'assets/icons/TrashFilled';
import Accordion from 'components/common/Accordion';
import BaseButton from 'components/ui/BaseButton';
import COLOR from 'constants/color';
import { SETTINGS_DELETE_TARGET } from 'enums';
import useConfirmSettingsDeletion from 'hooks/useConfirmSettingsDeletion';
import { CustomRoutineType } from 'interfaces/setting.interface';
import { t } from 'services/i18n.service';
import CustomRoutine from './custom-routine';

interface CustomRoutineListItemProps {
  routine: CustomRoutineType;
  index: number;
}

const CustomRoutineListItem = ({
  routine,
  index
}: CustomRoutineListItemProps) => {
  const handleDelete = useConfirmSettingsDeletion({
    target: SETTINGS_DELETE_TARGET.CUSTOM_ROUTINE,
    name: routine.name,
    position: index
  });

  return (
    <li
      className={`w-full ${!index ? '~mt-9/10' : 'mt-0'} flex items-start ~gap-2/3`}
      data-testid={`custom-routine-item-${index}`}>
      <BaseButton
        icon={
          <TrashFilled
            styles='~w-4/5 h-auto'
            fillDarkMode={COLOR.PRIMARY.LIGHT_700}
            fill={COLOR.PRIMARY.LIGHT_600}
          />
        }
        onClick={handleDelete}
        variant='icon'
        size='sm'
        additionalStyles='!p-0 relative ~top-1/3'
      />
      <div className='flex-1'>
        <Accordion
          title={routine.name.length > 0 ? routine.name : t('custom_routine')}
          open
          headerTitleStyles='font-medium !~text-xs/base italic ~px-0.5/2 ~py-0.5/1'>
          <CustomRoutine customRoutine={routine} position={index} />
        </Accordion>
      </div>
    </li>
  );
};

export default CustomRoutineListItem;
